var map = {
	"./ApplicationStatus.vue": [
		3268,
		392
	],
	"./Autosave.vue": [
		3269,
		441
	],
	"./ChangeAuthor.vue": [
		3270,
		442
	],
	"./ChangeType.vue": [
		3271,
		443
	],
	"./Cooldown.vue": [
		3272,
		393
	],
	"./CourseRelease.vue": [
		3273,
		394
	],
	"./Demo.vue": [
		3279,
		472
	],
	"./Demo2.vue": [
		3280,
		473
	],
	"./EditorSettings.vue": [
		3274,
		444
	],
	"./Hint.vue": [
		3267
	],
	"./ModuleRelease.vue": [
		3275,
		395
	],
	"./Practice.vue": [
		3276,
		396
	],
	"./Reorder.vue": [
		3277,
		445
	],
	"./Vacancies.vue": [
		3278,
		446
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 3134;
module.exports = webpackAsyncContext;